export const agenciesListKey = () => ["agencies-list"];

export const agenciesListParamsKey = ({ queryParams }) => [...agenciesListKey(), queryParams];
